import { Component, inject, OnDestroy } from '@angular/core';
import { catchError, firstValueFrom, of, Subscription, switchMap, take, timer } from 'rxjs';
import { EfateCakeRunApiService } from 'src/app/shared/services/efate-cake/efate-cake-run.api.service';

@Component({
  selector: 'app-ef-run',
  templateUrl: './ef-run.component.html',
})
export class EFRunComponent implements OnDestroy {
  private readonly efateCakeRunApiService = inject(EfateCakeRunApiService);
  private readonly statusIntervalMs = 5000;
  private readonly maxConsecutiveErrors = 5;
  private statusSubscription?: Subscription;

  isLoading: boolean = false;
  isReady: boolean = false;
  result: any;

  async runCake(efateSetupPk?: number): Promise<void> {
    this.stopMonitoring();
    this.isReady = false;
    this.result = undefined;

    if (!efateSetupPk || efateSetupPk <= 0) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    try {
      await firstValueFrom(this.efateCakeRunApiService.startCAKE(efateSetupPk).pipe(take(1)));
    } catch (error) {
      console.warn('Error starting CAKE', error);
      this.isLoading = false;
      return;
    }

    this.monitorCake(efateSetupPk);
  }

  ngOnDestroy(): void {
    this.stopMonitoring();
  }

  private monitorCake(efateSetupPk: number): void {
    let consecutiveErrors = 0;

    this.statusSubscription = timer(0, this.statusIntervalMs).pipe(
      switchMap(() => this.efateCakeRunApiService.getCAKEStatus(efateSetupPk).pipe(
        take(1),
        catchError((error) => {
          console.warn('Error getting CAKE status', error);
          return of(null);
        })
      ))
    ).subscribe((status: any) => {
      if (!status) {
        if (++consecutiveErrors >= this.maxConsecutiveErrors) {
          this.stopMonitoring();
          this.isLoading = false;
        }
        return;
      }

      consecutiveErrors = 0;

      if (status.status === 'Running') {
        return;
      }

      this.stopMonitoring();
      this.isLoading = false;

      if (status.status === 'Completed') {
        this.result = status.result;
        console.log('RunCAKE response', this.result);
        this.isReady = true;
      } else {
        console.warn('Error running CAKE', status.error ?? status.status);
      }
    });
  }

  private stopMonitoring(): void {
    this.statusSubscription?.unsubscribe();
    this.statusSubscription = undefined;
  }
}